import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { login, setCurAuthen } from "../../features/UserProfie";
import { HttpJsonHeader } from "../../features/Environments";
import axios from "axios";
import { setReminder } from "../../features/UserActions";
import { decode, encode } from "js-base64";

import { useEffect } from "react";
import styled from "styled-components";
import { VersionService } from "../../model/version";
import { FormControl } from "react-bootstrap";
import "./login.css";

function Login() {
  const userRef = useRef();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [chkInfo, setChkInfo] = useState(false);
  const [errMesage, setErrMessage] = useState("");
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const checkVer = async () => {
    if ((await VersionService.IsCurrentVersion()) === false) {
      // console.log("version mismatch");
      alert("ต้องการโหลดอีกเครั้งเพื่อ update version");
      window.location.reload();
    }
  };

  useEffect(() => {
    //console.log("coming");

    checkVer();
    return () => {
      console.log("return");
    };
  }, []);

  const checkUser = () => {
    setLoading(true);
    axios
      .post(
        process.env.REACT_APP_API + "user/authen",
        {
          data: encode(
            JSON.stringify({ Username: username, Password: password })
          ),
        },
        HttpJsonHeader
      )
      .then((response) => {
        var result = JSON.parse(decode(response.data));
        dispatch(login(result));
        dispatch(
          setCurAuthen({ username: username, password: encode(password) })
        );

        window.history.pushState({}, "", "/");
        if (chkInfo) {
          localStorage.setItem("raduser", encode(username + "XvEz" + password));
        }
        setLoading(false);
      })
      .catch((err) => {
        // console.log(err);
        setLoading(false);
        dispatch(
          setReminder({
            show: true,
            message: "Username Not Found",
            type: "error",
          })
        );
        setErrMessage("ไม่พบผู้ใช้งาน");
      });
  };

  return (
    <div class="main-body">
      <svg style={{ position: "absolute", width: "0", height: "0" }}>
        <defs>
          <filter id="round">
            <feGaussianBlur
              in="SourceGraphic"
              stdDeviation="1.2"
              result="blur"
            />
            <feColorMatrix
              in="blur"
              mode="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 22 -11"
              result="goo"
            />
            <feComposite in="SourceGraphic" in2="goo" operator="atop" />
          </filter>
        </defs>
      </svg>

      <div class="login-container">
        <div class="login-header">
          <div class="abstract-shape shape-1"></div>
          <div class="abstract-shape shape-2"></div>
          <div class="abstract-shape shape-3"></div>
          <div class="logo-container">
            <div class="logo-typography">
              <div class="ont-main">
                <div class="ont-text">ONT</div>
              </div>
              <div class="ont-subtitle">Open Network Telerad</div>
            </div>
          </div>
        </div>

        <div class="login-form">
          <h2 class="form-title">เข้าสู่ระบบ</h2>
          <p class="form-subtitle">กรุณากรอกข้อมูลเพื่อเข้าใช้งาน</p>

          <form id="loginForm" onSubmit={(e) => e.preventDefault()}>
            <div class="input-group-x">
              <label for="username">ชื่อผู้ใช้งาน</label>
              <div class="input-wrapper">
                <input
                  type="text"
                  id="username"
                  name="username"
                  placeholder="กรอกชื่อผู้ใช้งาน"
                  required
                  onChange={(e) => setUsername(e.target.value)}
                />
                <span class="input-icon">👤</span>
              </div>
            </div>

            <div class="input-group-x">
              <label for="password">รหัสผ่าน</label>
              <div class="input-wrapper">
                <input
                  type="password"
                  id="password"
                  name="password"
                  placeholder="กรอกรหัสผ่าน"
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span class="input-icon">🔒</span>
              </div>
            </div>

            <div class="remember-forgot">
              <div class="remember-me">
                <input
                  type="checkbox"
                  id="remember"
                  name="remember"
                  onChange={(e) => {
                    setChkInfo(e.target.checked);
                  }}
                />
                <label for="remember">จดจำการเข้าสู่ระบบ</label>
              </div>
              <a href="#" class="forgot-password">
                ลืมรหัสผ่าน?
              </a>
            </div>

            <button
              onClick={() => {
                checkUser();
              }}
              class="login-button"
            >
              เข้าสู่ระบบ
            </button>
          </form>

          <div class="divider">
            <span>หรือ</span>
          </div>

          <div class="register-link">
            ยังไม่มีบัญชี? <a href="#">สมัครสมาชิก</a>
          </div>
        </div>

        <div class="footer">
          <div style={{ marginBottom: "8px" }}>
            © 2024 Open Network Telerad. All rights reserved.
          </div>
          <div
            style={{ fontSize: "11px", color: " #66bb6a", lineHeight: "1.5" }}
          >
            86/7 Moo Baan Ba-ngor Sae, Moo 6 • Tambon Tanyongmas, Amphoe Ra-ngae
            <br />
            Narathiwat Province 96130 • Thailand
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
